export default __webpack_public_path__ + "static/media/bg.a743051e.jpg";